import * as Sentry from "@sentry/react";

/**
 * Log error to Sentry
 * @param {string} message
 * @param {("debug" | "error" | "fatal" | "info" | "log" | "warning")} level
 */
export default function logToSentry(message, level = "debug") {
  if (!message) {
    return false;
  }

  if (!level) {
    level = "debug";
  }

  if (process.env.NODE_ENV !== "development") {
    try {
      return Sentry.captureMessage(message, level);
    } catch (error) {}
  } else {
    console.log(`${level.toUpperCase()}: ${message}`);
  }
}
